module.exports = __webpack_public_path__ + "img/liu.da424ed5.svg";